import { parseISO } from 'date-fns';
import { BellSimpleIcon, UsersIcon } from '@phosphor-icons/react';
import type { Icon } from '@phosphor-icons/react';
import { SecurityCameraIconMirrored } from '@/utils/icons';
import type { ActivityPulse, MetricWithDelta } from '@/types/admin-settings';
import { formatShortMonthDay } from '@/utils/date';

export interface MetricItem {
    icon: Icon;
    label: string;
    metric: MetricWithDelta;
}

export function buildMetrics(
    pulse: ActivityPulse,
    t: (key: string) => string,
): MetricItem[] {
    return [
        {
            icon: UsersIcon,
            label: t('organization.activityPulse.activeUsers'),
            metric: pulse.activeUsers,
        },
        {
            icon: SecurityCameraIconMirrored,
            label: t('organization.activityPulse.sourcesAdded'),
            metric: pulse.sourcesAdded,
        },
        {
            icon: BellSimpleIcon,
            label: t('organization.activityPulse.alertVolume'),
            metric: pulse.alertVolume,
        },
    ];
}

export function formatDayTick(value: string): string {
    const parsed = parseISO(value);
    if (Number.isNaN(parsed.getTime())) return value;
    return formatShortMonthDay(parsed);
}

export function formatFingerprint(value: string): string {
    const groups = value.match(/^([A-Z2-7]{7})-?([A-Z2-7]{7})$/i);
    if (groups) {
        return `${groups[1]}-${groups[2]}`.toUpperCase();
    }
    return value.length > 20
        ? `${value.slice(0, 12)}…${value.slice(-6)}`
        : value;
}
